import { Box } from '@mui/material'
import UserCard from 'common/components/UserCard'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import InformeData from '../components/InformeData'
import MenuInforme from '../components/MenuInforme'
import { InformesProvider } from '../providers/InformesProvider'

const Informes = ({ object: forced_id }) => {
  const location = useLocation()

  const [report, setReport] = useState(forced_id)

  const [userData, _] = useState({
    user: location?.state?.user ?? null,
    surname: location?.state?.surname ?? null,
    name: location?.state?.name ?? null,
    image: location?.state?.image ?? null,
  })

  useEffect(() => {
    if (location?.state?.report) {
      setReport(location.state.report)
    } else if (location.pathname === '/informes' && !location?.state?.report) {
      setReport(null)
    }
  }, [location])

  return (
    <Box>
      {userData.user ? <UserCard datos={userData} /> : null}
      <InformesProvider>
        {!report ? <MenuInforme /> : <></>}
        <InformeData forced={report} />
      </InformesProvider>
    </Box>
  )
}

export default Informes
